import { render } from "./AppShell.vue?vue&type=template&id=c0f84f98&scoped=true"
import script from "./AppShell.vue?vue&type=script&lang=js"
export * from "./AppShell.vue?vue&type=script&lang=js"

import "./AppShell.vue?vue&type=style&index=0&id=c0f84f98&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c0f84f98"

export default script